import $ from 'jquery';

export default () => {
    const preview = $('.js-newsletter-preview');
    const modal = $('.js-newsletter-modal');

    preview.on('click', function() {
        modal.addClass('is-active');
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/newsletter.js